import {Component, Input, OnInit} from '@angular/core';
import {IonCol, IonImg, IonRow} from '@ionic/angular/standalone';

@Component({
  selector: 'app-service-content',
  templateUrl: './service-content.component.html',
  styleUrls: ['./service-content.component.scss'],
  imports: [
    IonImg
  ]
})
export class ServiceContentComponent  implements OnInit {

  @Input() imgPath: string = '';
  @Input() number: string = '';
  @Input() title: string = '';
  @Input() content: string = '';
  @Input() direction: string = '';
  constructor() { }

  ngOnInit() {}

}
